/* import __COLOCATED_TEMPLATE__ from './infinite-scroll-selection-modal.hbs.js'; */
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import * as Sentry from '@sentry/ember';
let InfiniteScrollSelectionModal = (_class = class InfiniteScrollSelectionModal extends Component {
  constructor(owner, args) {
    super(owner, args);
    _initializerDefineProperty(this, "isLoadingMoreOptions", _descriptor, this);
    _initializerDefineProperty(this, "intl", _descriptor2, this);
    _initializerDefineProperty(this, "currentSelectionState", _descriptor3, this);
    _initializerDefineProperty(this, "searchTerm", _descriptor4, this);
    _initializerDefineProperty(this, "isSearchingOptions", _descriptor5, this);
    this.currentSelectionState = {
      ...this.args.selectionState,
      selectedOptionIds: new Set(this.args.selectionState.selectedOptionIds),
      deselectedOptionIds: new Set(this.args.selectionState.deselectedOptionIds)
    };
  }
  get modalOptions() {
    return {
      enableSelectAll: true,
      title: this.intl.t('sharedUi.infiniteScrollSelectionModal.title'),
      primaryButtonLabel: this.intl.t('sharedUi.common.done'),
      selectAllLabel: this.intl.t('sharedUi.infiniteScrollSelectionModal.selectAllLabel'),
      searchPlaceholder: this.intl.t('sharedUi.infiniteScrollSelectionModal.searchPlaceholder'),
      ...this.args.modalOptions
    };
  }
  get optionsValue() {
    return this.options.filter(option => option.checked).map(option => option.id);
  }
  get options() {
    return this.args.options.map(option => {
      if (option.disabled) {
        return option;
      }
      let checked;
      if (this.currentSelectionState.selectedAllOptions) {
        checked = !this.currentSelectionState.deselectedOptionIds.has(option.id);
      } else if (this.currentSelectionState.deselectedAllOptions) {
        checked = this.currentSelectionState.selectedOptionIds.has(option.id);
      } else {
        checked = this.currentSelectionState.selectedOptionIds.has(option.id);
      }
      return {
        ...option,
        checked
      };
    });
  }
  get hasIndividuallySelectedAllOptions() {
    const {
      selectedOptionIds
    } = this.currentSelectionState;
    return selectedOptionIds.size === this.args.options.length && !this.args.hasMoreOptions;
  }
  get isSelectAllCheckboxChecked() {
    const {
      selectedAllOptions,
      deselectedOptionIds
    } = this.currentSelectionState;
    const allSelected = selectedAllOptions && deselectedOptionIds.size === 0;
    return allSelected || this.hasIndividuallySelectedAllOptions;
  }
  get hasNoSearchResults() {
    return this.searchTerm.length > 0 && this.options.length === 0 && !this.isSearchingOptions;
  }
  get hasNoOptions() {
    return this.options.length === 0 && !this.isLoadingMoreOptions && !this.isSearchingOptions;
  }
  selectAllClicked() {
    // Check if currently not all options are selected
    if (!this.isSelectAllCheckboxChecked || this.currentSelectionState.deselectedOptionIds.size > 0) {
      // Select all options
      this.currentSelectionState.selectedAllOptions = true;
      this.currentSelectionState.deselectedAllOptions = false;
      this.currentSelectionState.selectedOptionIds.clear();
      this.currentSelectionState.deselectedOptionIds.clear();
    } else {
      // Deselect all options
      this.currentSelectionState.selectedAllOptions = false;
      this.currentSelectionState.deselectedAllOptions = true;
      this.currentSelectionState.selectedOptionIds.clear();
      this.currentSelectionState.deselectedOptionIds.clear();
    }
    this.refreshCurrentSelectionState();
  }
  optionClicked(optionId) {
    const {
      selectedOptionIds,
      deselectedOptionIds,
      selectedAllOptions,
      deselectedAllOptions
    } = this.currentSelectionState;
    if (selectedAllOptions) {
      if (deselectedOptionIds.has(optionId)) {
        deselectedOptionIds.delete(optionId);
      } else {
        deselectedOptionIds.add(optionId);
      }
    } else if (deselectedAllOptions) {
      if (selectedOptionIds.has(optionId)) {
        selectedOptionIds.delete(optionId);
      } else {
        selectedOptionIds.add(optionId);
      }
    } else {
      if (selectedOptionIds.has(optionId)) {
        selectedOptionIds.delete(optionId);
        deselectedOptionIds.add(optionId);
      } else if (deselectedOptionIds.has(optionId)) {
        deselectedOptionIds.delete(optionId);
        selectedOptionIds.add(optionId);
      } else {
        selectedOptionIds.add(optionId);
      }
    }
    this.refreshCurrentSelectionState();
  }
  refreshCurrentSelectionState() {
    this.currentSelectionState = {
      selectedOptionIds: new Set(this.currentSelectionState.selectedOptionIds),
      deselectedOptionIds: new Set(this.currentSelectionState.deselectedOptionIds),
      selectedAllOptions: this.currentSelectionState.selectedAllOptions,
      deselectedAllOptions: this.currentSelectionState.deselectedAllOptions
    };
  }
  async handleScroll() {
    if (this.isLoadingMoreOptions || !this.args.hasMoreOptions) {
      return;
    }
    try {
      this.isLoadingMoreOptions = true;
      await this.args.loadMoreOptions();
    } catch (err) {
      Sentry.captureException(err);
    } finally {
      this.isLoadingMoreOptions = false;
    }
  }
  async searchTermChanged(newSearchTerm) {
    try {
      this.isSearchingOptions = true;
      this.searchTerm = newSearchTerm;
      await this.args.onSearchOptions(this.searchTerm);
    } catch (err) {
      Sentry.captureException(err);
    } finally {
      this.isSearchingOptions = false;
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "isLoadingMoreOptions", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "currentSelectionState", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "searchTerm", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "isSearchingOptions", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "selectAllClicked", [action], Object.getOwnPropertyDescriptor(_class.prototype, "selectAllClicked"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "optionClicked", [action], Object.getOwnPropertyDescriptor(_class.prototype, "optionClicked"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleScroll", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleScroll"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "searchTermChanged", [action], Object.getOwnPropertyDescriptor(_class.prototype, "searchTermChanged"), _class.prototype), _class);
export { InfiniteScrollSelectionModal as default };